import slice from './slice'

export const { reducer } = slice
